import axios from 'axios';
import pjson from '../../package.json';
import {
  errorHandler,
  setAxiosRequestConfig,
  setAxiosResponseConfig,
  setData,
} from './axios';
const { REACT_APP_BASEURL, REACT_APP_MOVCAD_LEGACY } = process.env;

// #region    Axios criação de instância

export const legado = axios.create({
  baseURL: REACT_APP_MOVCAD_LEGACY,
});

export const authApi = axios.create({
  baseURL: `${REACT_APP_BASEURL}`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-api-key': pjson.version,
  },
});

export const OAuth = axios.create({
  baseURL: `${REACT_APP_BASEURL}`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-api-key': pjson.version,
  },
});

export const OAuthNewToken = axios.create({
  baseURL: `${REACT_APP_BASEURL}`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-api-key': pjson.version,
  },
});

export const listasAPI = axios.create({
  baseURL: `${REACT_APP_BASEURL}/listas`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-api-key': pjson.version,
  },
});

export const requisitionAPI = axios.create({
  baseURL: `${REACT_APP_BASEURL}/requisition`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-api-key': pjson.version,
  },
});

export const WebhookIntegrationAPI = axios.create({
  baseURL: `${REACT_APP_BASEURL}/webhook`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-api-key': pjson.version,
  },
});
export const WebhookEventIntegrationAPI = axios.create({
  baseURL: `${REACT_APP_BASEURL}/webhook/event`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-api-key': pjson.version,
  },
});
export const WebhookEventHeaderIntegrationAPI = axios.create({
  baseURL: `${REACT_APP_BASEURL}/webhook/event/header`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-api-key': pjson.version,
  },
});

export const TaskAPi = axios.create({
  baseURL: `${REACT_APP_BASEURL}/tasks`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-api-key': pjson.version,
  },
});

export const ArquivoUploadAPI = axios.create({
  baseURL: `${REACT_APP_BASEURL}/arquivo-upload`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-api-key': pjson.version,
  },
});

export const listasMassaInicialAPI = axios.create({
  baseURL: `${REACT_APP_BASEURL}/listas/`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-api-key': pjson.version,
  },
});

export const contratantesAPI = axios.create({
  baseURL: `${REACT_APP_BASEURL}/contratantes`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-api-key': pjson.version,
  },
});

export const UsuariosAPI = axios.create({
  baseURL: `${REACT_APP_BASEURL}/usuarios`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-api-key': pjson.version,
  },
});

export const ListasRPAAPI = axios.create({
  baseURL: `${REACT_APP_BASEURL}/listas-rpa`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-api-key': pjson.version,
  },
});

export const BeneficiariosAPI = axios.create({
  baseURL: `${REACT_APP_BASEURL}/beneficiarios`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-api-key': pjson.version,
  },
});

export const TesteAPI = axios.create({
  baseURL: 'http://localhost:44301/api/v1/',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-api-key': pjson.version,
  },
});

export const GoogleRecaptchaAPI = axios.create({
  baseURL: 'https://www.google.com/recaptcha/api',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-api-key': pjson.version,
  },
});

export const ParametroAPI = axios.create({
  baseURL: `${REACT_APP_BASEURL}/parametrizacao-movcad`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-api-key': pjson.version,
  },
});

export const RelatoriosAPI = axios.create({
  baseURL: `${REACT_APP_BASEURL}/relatorios`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-api-key': pjson.version,
  },
});

export const CheckListDocumentosAPI = axios.create({
  baseURL: `${REACT_APP_BASEURL}/check-list-documetos`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-api-key': pjson.version,
  },
});

export const ListaInativosAPI = axios.create({
  baseURL: `${REACT_APP_BASEURL}/cadastro-inativos`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-api-key': pjson.version,
  },
});

// #endregion

// #region    AxiosRequest Configuração
listasAPI.interceptors.request.use(async (config) =>
  setAxiosRequestConfig(config)
);
requisitionAPI.interceptors.request.use(async (config) =>
  setAxiosRequestConfig(config)
);
WebhookIntegrationAPI.interceptors.request.use(async (config) =>
  setAxiosRequestConfig(config)
);
WebhookEventIntegrationAPI.interceptors.request.use(async (config) =>
  setAxiosRequestConfig(config)
);
WebhookEventHeaderIntegrationAPI.interceptors.request.use(async (config) =>
  setAxiosRequestConfig(config)
);
ArquivoUploadAPI.interceptors.request.use(async (config) =>
  setAxiosRequestConfig(config)
);
TaskAPi.interceptors.request.use(async (config) =>
  setAxiosRequestConfig(config)
);

contratantesAPI.interceptors.request.use(async (config) =>
  setAxiosRequestConfig(config)
);

UsuariosAPI.interceptors.request.use(async (config) =>
  setAxiosRequestConfig(config)
);

OAuthNewToken.interceptors.request.use(async (config) =>
  setAxiosRequestConfig(config)
);

BeneficiariosAPI.interceptors.request.use(async (config) =>
  setAxiosRequestConfig(config)
);

listasMassaInicialAPI.interceptors.request.use(async (config) =>
  setData(config)
);
ParametroAPI.interceptors.request.use(async (config) =>
  setAxiosRequestConfig(config)
);
RelatoriosAPI.interceptors.request.use(async (config) =>
  setAxiosRequestConfig(config)
);
CheckListDocumentosAPI.interceptors.request.use(async (config) =>
  setAxiosRequestConfig(config)
);
ListaInativosAPI.interceptors.request.use(async (config) =>
  setAxiosRequestConfig(config)
);
OAuth.interceptors.request.use(async (config) => setData(config));
// #endregion

// #region    AxiosResponse Configuração
listasAPI.interceptors.response.use(
  (response) => setAxiosResponseConfig(response),
  (error) => errorHandler(error, 'lista')
);

requisitionAPI.interceptors.response.use(
  (response) => setAxiosResponseConfig(response),
  (error) => errorHandler(error, 'segunda-via')
);
WebhookIntegrationAPI.interceptors.response.use(
  (response) => setAxiosResponseConfig(response),
  (error) => errorHandler(error, 'configuracoes')
);
WebhookEventIntegrationAPI.interceptors.response.use(
  (response) => setAxiosResponseConfig(response),
  (error) => errorHandler(error, 'configuracoes')
);

WebhookEventHeaderIntegrationAPI.interceptors.response.use(
  (response) => setAxiosResponseConfig(response),
  (error) => errorHandler(error, 'configuracoes')
);

ArquivoUploadAPI.interceptors.response.use(
  (response) => setAxiosResponseConfig(response),
  (error) => errorHandler(error, 'relatorio')
);

TaskAPi.interceptors.response.use(
  (response) => setAxiosResponseConfig(response),
  (error) => errorHandler(error, 'relatorio')
);

listasMassaInicialAPI.interceptors.response.use(
  (response) => setAxiosResponseConfig(response),
  (error) => errorHandler(error, 'massa-inicial')
);

contratantesAPI.interceptors.response.use(
  (response) => setAxiosResponseConfig(response),
  (error) => errorHandler(error, 'lista')
);
UsuariosAPI.interceptors.response.use(
  (response) => setAxiosResponseConfig(response),
  (error) => errorHandler(error, 'gestao')
);
BeneficiariosAPI.interceptors.response.use(
  (response) => setAxiosResponseConfig(response),
  (error) => errorHandler(error, 'gestao')
);
ParametroAPI.interceptors.response.use(
  (response) => setAxiosResponseConfig(response),
  (error) => errorHandler(error, 'gestao')
);
RelatoriosAPI.interceptors.response.use(
  (response) => setAxiosResponseConfig(response),
  (error) => errorHandler(error, 'lista')
);

CheckListDocumentosAPI.interceptors.response.use(
  (response) => setAxiosResponseConfig(response),
  (error) => errorHandler(error, 'lista')
);
ListaInativosAPI.interceptors.response.use(
  (response) => setAxiosResponseConfig(response),
  (error) => errorHandler(error, 'lista')
);
// #endregion
